import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../../core/services/user.service';
import { environment } from '../../../../environments/environment';
import { TurnstileComponent } from '../../../shared/components/turnstile/turnstile.component';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
// forgot-password.component.ts
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends BaseComponent {
  forgotPasswordForm: FormGroup;
  @Output() loginClick = new EventEmitter<void>();

  turnstileToken = '';
  @ViewChild('challenge') challenge?: TurnstileComponent;

  /** Submit is gated on a solved challenge; skipped when Turnstile isn't configured. */
  get challengeReady(): boolean {
    if (!environment.TURNSTILE_SITE_KEY) return true;
    return !!this.turnstileToken;
  }

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    fs: FeedbackService,
    md: MatDialog
  ) {

    super(fs, md);
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit() {
    if (this.forgotPasswordForm.valid && this.challengeReady) {
      const { email } = this.forgotPasswordForm.value;
      const sub = this.userService.forgotPassword(email, this.turnstileToken).subscribe(
        (response: any) => {
          if (response.success) {
            // Password reset email sent successfully
            this.showToastMessage('A password reset link has been sent to the provided email address.');
          } else {
            // Password reset request failed
            //console.error(response.message);
            if (response.code === 'SENSITIVE_RATE_LIMIT_EXCEEDED') {
              this.showToastMessage('Too many password reset requests. Please try again later');
            }
            else {
              this.showToastMessage('There was an error requesting a password reset for the provided email address. Please try again.');
            }
          }
          this.resetChallenge();
          sub.unsubscribe();
        },
        (error: any) => {
          //console.error('Error requesting password reset:', error);
          if (error.error.code === 'SENSITIVE_RATE_LIMIT_EXCEEDED') {
            this.showToastMessage('Too many password reset requests. Please try again later');
          }
          else if (error.error?.code === 'TURNSTILE_TOKEN_MISSING' || error.error?.code === 'TURNSTILE_VERIFICATION_FAILED' || error.error?.code === 'TURNSTILE_VERIFICATION_ERROR') {
            this.showToastMessage('Challenge verification failed. Please try again.');
          }
          else {
            this.showToastMessage('There was an error requesting a password reset for the provided email address. Please try again.');
          }
          this.resetChallenge();
          sub.unsubscribe();
        }
      );
    }
  }

  /** Clears the solved challenge so a repeat submit must solve a fresh one. */
  private resetChallenge() {
    this.turnstileToken = '';
    this.challenge?.reset();
  }

  onLoginClick() {
    this.loginClick.emit();
  }
}